import jwtDefaultConfig from './jwtDefaultConfig'

export default class JwtService {
  // Will be used by this service for making API calls
  axiosIns = null

  // jwtConfig <= Will be used by this service
  jwtConfig = { ...jwtDefaultConfig }

  // For Refreshing Token
  isAlreadyFetchingAccessToken = false

  // For Refreshing Token
  subscribers = []

  // For redirecting to login page
  routerInstance = null

  constructor(axiosIns) {
    this.axiosIns = axiosIns

    // Request Interceptor
    this.axiosIns.interceptors.request.use(
      config => config,
      error => Promise.reject(error),
    )

    // Add request/response interceptor
    this.axiosIns.interceptors.response.use(
      response => response,
      error => {
        // const { config, response: { status } } = error
        const { config, response } = error
        const originalRequest = config

        // if (status === 401) {
        if (response && response.status === 401) {
          if (config.url === '/auth/context') {
            return Promise.reject(error)
          }

          if (response.data.code === 'E_INVALID_DISCORD_REFRESH_REQUEST') {
            // If token is invalid remove it from localStorage
            this.removeUserData()
            this.isAlreadyFetchingAccessToken = false
            this.subscribers = []

            // Redirect user to login page
            if (window.location.pathname !== '/login') {
              if (this.routerInstance) {
                this.routerInstance.push({ name: 'login' })
              } else {
                window.location.href = '/login'
              }
            }

            return Promise.reject(error)
          }

          if (originalRequest.isRetry) return Promise.reject(error)
          originalRequest.isRetry = true

          const retryOriginalRequest = new Promise(resolve => {
            this.addSubscriber(() => {
              resolve(this.axiosIns(originalRequest))
            })
          })

          if (!this.isAlreadyFetchingAccessToken) {
            this.isAlreadyFetchingAccessToken = true
            this.onAccessTokenFetched()
          }

          return retryOriginalRequest
        }

        if (response && response.status === 500) {
          if (response.data.code === 'FAST_JWT_INVALID_SIGNATURE') {
            // If token is invalid remove it from localStorage
            this.removeUserData()
            this.isAlreadyFetchingAccessToken = false
            this.subscribers = []

            // Redirect user to login page
            if (window.location.pathname !== '/login') {
              if (this.routerInstance) {
                this.routerInstance.push({ name: 'login' })
              } else {
                window.location.href = '/login'
              }
            }

            return Promise.reject(error)
          }
        }

        // Other errors
        return Promise.reject(error)
      },
    )
  }

  onAccessTokenFetched() {
    this.subscribers = this.subscribers.filter(callback => callback())
    this.isAlreadyFetchingAccessToken = false
  }

  addSubscriber(callback) {
    this.subscribers.push(callback)
  }

  removeUserData() {
    localStorage.removeItem(this.jwtConfig.userDataKeyName)
  }

  login(next = null) {
    const loginUrl = encodeURIComponent(
      `${window.location.origin}${window.location.pathname}${next ? `?next=${next}` : ''}`,
    )
    return this.axiosIns.get(this.jwtConfig.loginEndpoint, { params: { redirect: loginUrl } })
  }

  loginCallback({ code, next }) {
    const loginUrl = encodeURIComponent(
      `${window.location.origin}${window.location.pathname}${next ? `?next=${next}` : ''}`,
    )
    return this.axiosIns.get(this.jwtConfig.loginCallbackEndpoint, { params: { code, redirect: loginUrl } })
  }

  fetchWebsocketToken() {
    return this.axiosIns.get(this.jwtConfig.websocketAuthToken)
  }
}
